import { useEffect } from "react";

export const useOnUnmount = (callback: () => void): void => {
    useEffect(() => {
        return callback;
    }, []);
};
